import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { api } from "../../../../../../../../../../services/Api/api";
import { OrganizationMeApi } from "../../../../../../../../../../services/Api/types";
import { api as securityApi } from "../../../../../../../../../../services/Security/api";
import { selectOrganization } from "../../../../../../../../../../services/organizations/selectors";
import OrganizationBasicInfoForm from "./components/OrganizationBasicInfoForm";

const OrganizationSettingsPageOrganizationBasicInfoPage = () => {
	const [details, setDetails] = useState<OrganizationMeApi | undefined>(undefined);
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const organization = useSelector(selectOrganization);
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { t } = useTranslation();

	useEffect(() => {
		handleChangeTabTitle(t("modules.settings.field.organization_data.title"));
		fetchResourceConfig();
		fetchOrganizationMeDetails();
	}, []);

	const fetchOrganizationMeDetails = async () => {
		try {
			const params: Record<string, any> = {};
			params.include = "place,custom_fields";
			if (organization && organization.id) {
				const res = await securityApi.user().getOrganization(organization.id, params);
				setDetails(res);
			}
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchResourceConfig = async () => {
		try {
			const params = {
				resource_name: "ORGANIZATION",
				custom_field_resource_type: "ORGANIZATION",
				custom_field_permission_scope: "WRITE",
			};
			const res = await api.getResourceConfig(params);
			setCustomFieldsConfig(res.custom_fields);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return !details || !customFieldsConfig ? (
		<LoadingContainer />
	) : (
		<OrganizationBasicInfoForm details={details} customFieldsConfig={customFieldsConfig} />
	);
};

export default OrganizationSettingsPageOrganizationBasicInfoPage;
